import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './NavigationBar.scss';

function NavigationItem({ title, content, isOpen, setIsOpen, href }) {
  const toggleDropdown = (e) => {
    e.stopPropagation(); // Cela empêche le clic de se propager au document
    setIsOpen(isOpen === title ? null : title);
  };

  const link = href ? (
    <NavLink to={href} className={({ isActive }) => "nav-title" + (isActive ? " active" : "")} onClick={toggleDropdown}>
      {title}
    </NavLink>
  ) : (
    <button className="nav-title" onClick={toggleDropdown}>
      {title}
    </button>
  );

  return (
    <div className={`nav-item${isOpen ? " active" : ""}`}>
      {link}
      {isOpen && <div className="dropdown-content">{content}</div>}
    </div>
  );
}

function DropdownList({ items }) {
  const [hovered, setHovered] = useState(null);

  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            className={hovered === index ? "hovered" : ""}>
          {item}
          {hovered === index && <span className="validation-icon">✔</span>}
        </li>
      ))}
    </ul>
  );
}

function NavigationBar() {
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const closeDropdown = (e) => {
      if (!e.target.closest('.dropdown-content') && !e.target.closest('.nav-title')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('click', closeDropdown);
    return () => document.removeEventListener('click', closeDropdown);
  }, []);

  const dropdownContent = (
    <DropdownList items={[
      "Популярные",
      "Новинки",
      "Сначала дешевые",
      "Сначала дорогие",
      "По размеру скидки",
      "Высокий рейтинг"
    ]} />
  );

  const navItems = [
    { title: "CURRENCY", content: dropdownContent },
    { title: "RANKING", content: dropdownContent }
  ];

  return (
    <div className="navigation-bar">
      <div className="branding">
        <span className="brand-name">TD</span>
      </div>
      <div className="nav-items">
        {navItems.map(item => (
          <NavigationItem
            key={item.title}
            title={item.title}
            content={item.content}
            isOpen={openDropdown === item.title}
            setIsOpen={setOpenDropdown}
            href={item.href}
          />
        ))}
      </div>
    </div>
  );
}

export default NavigationBar;
